import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import { LessonState } from '../../../helpers/constants';
import { toCSS } from '../../../helpers/styles';
import { fileResourceUrl } from '../../../utils/urlUtils';
import { TrackCoverage } from '../../Catiz/Map/TrackCoverage';

export interface ITrackProps {
  xPosition: number;
  yPosition: number;
  track: string;
  doMovement: any;
  coverage: any;
}

interface Position {
  x: number;
  y: number;
  width: number;
  height: number;
  duration: number;
}

const TrackContainer = styled.div<Position>`
  position: absolute;
  cursor: pointer;
  ${({ x, y, width, height, duration }) => `
        left: ${toCSS(+x - +width / 2)};
        top: ${toCSS(+y - +height / 2)};
        transition: left ${duration}ms ease, top ${duration}ms ease;
    `};

  > img {
    ${({ width, height }) => `
      width: ${toCSS(width)};
      height: ${toCSS(height)};
    `}

    object-fit: contain;
  }
`;

const NameContainer = styled.div`
  display: inline-block;
  margin: 0;
  position: relative;
  top: -2px;
  left: 4px;
`;

export default function Track(props: ITrackProps) {
  const { track, doMovement, xPosition, yPosition, coverage } = props;
  const [movement, setMovement] = useState<any>();
  const [resource, setResource] = useState<any>();
  const [trackName, setTrackName] = useState<any>('');
  const isOffline = useSelector(
    (state: any) => state.resources.offlineMode
  );
  const [animateIndex, setAnimateIndex] = useState(0);
  const intervalRef = useRef<any>();
  const res = useSelector((state: any) => track && state.resources[track]);
  const [pos, setPos] = useState<any>();
  useEffect(() => {
    setPos({
      x: xPosition,
      y: yPosition,
      width: +res['defaultTrack'].width,
      height: +res['defaultTrack'].height,
    });
  }, [res]);
  const token = useSelector((state: any) => state.authenticate.token);
  const lessonStatus = useSelector((state: any) => state.executor.status);
  const resources = useSelector((state: any) => state.resources);

  useEffect(() => {
    if (doMovement && res) {
      if (
        res.defaultTrack &&
        res.defaultTrack.movements &&
        res.defaultTrack.movements[0]
      )
        setMovement(res.defaultTrack.movements[0].movement);
    }
  }, [doMovement, res]);

  useEffect(() => {
    if (lessonStatus === LessonState.STARTED) {
      if (track && movement && animateIndex < movement.path.length) {
        intervalRef.current = setTimeout(() => {
          const { position } = movement.path[animateIndex || 0];
          setPos({
            x: +position.x,
            y: +position.y,
            width: +res['defaultTrack'].width,
            height: +res['defaultTrack'].height,
          });
          setAnimateIndex((index: any) => index + 1);
        }, +movement.interval);
      }
    }
    return () => {
      if (intervalRef.current) {
        clearTimeout(intervalRef.current);
      }
    };
  }, [track, movement, animateIndex, lessonStatus]);
  useEffect(() => {
    if (track && res) {
      setTrackName(res['defaultTrack'].displayName);
      const { value, filename } = res['trackIcon'];
      setResource(fileResourceUrl(token, value, filename, isOffline));
    }
  }, [track, res, token]);
  return (
    <React.Fragment>
      <TrackContainer
        {...props}
        {...pos}
        duration={movement && +movement.interval}
      >
        {resource && (
          <React.Fragment>
            <img src={resource} />
            <NameContainer>{trackName}</NameContainer>
          </React.Fragment>
        )}
      </TrackContainer>
      {coverage && <TrackCoverage {...pos} {...coverage} />}
    </React.Fragment>
  );
}
